import templateUrl from "emun.auth/change-password/change-password.htm";
import controller from "emun.auth/change-password/change-password.controller";

export default {
  bindings: {
    errors: "=?",
    resetId: "@",
    token: "@",
    submitLabel: "@",
    onSuccess: "&",
    onSuccessUrl: "@",
    callbackUrl: "@",
    onFail: "&"
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
